module["exports"] = [
  "com",
  "es",
  "info",
  "com.es",
  "org"
];
